import { CheckCircle, Clock } from 'lucide-react';

const JETSKI_ICON_URL = "https://static.prod-images.emergentagent.com/jobs/afd6378d-9473-4160-8feb-947e333517d2/images/2ebbeb4be00716d899bffe20bf67fc418811022213a582d61273768ac9b1f9a2.png";

const ETAPES = [
  { key: 'infos_administratives', label: 'Informations administratives' },
  { key: 'pieces_fournir', label: 'Pieces a fournir' },
  { key: 'paiement_frais', label: 'Paiement des frais' },
];

const ProgressCircle = ({ percent }) => {
  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <svg width="140" height="140" viewBox="0 0 140 140">
      <circle cx="70" cy="70" r={radius} fill="none" stroke="#1e293b" strokeWidth="8" />
      <circle
        cx="70" cy="70" r={radius} fill="none"
        stroke="#8DC63F" strokeWidth="8" strokeLinecap="round"
        strokeDasharray={circumference} strokeDashoffset={offset}
        transform="rotate(-90 70 70)"
        style={{ transition: 'stroke-dashoffset 1s ease-out' }}
      />
      <text x="70" y="62" textAnchor="middle" fill="#8DC63F" fontSize="28" fontWeight="bold">{percent}%</text>
      <text x="70" y="82" textAnchor="middle" fill="#94a3b8" fontSize="11">Complété</text>
    </svg>
  );
};

const DossierValideCard = ({ etapes, dateValidation, candidatNom }) => {
  const completed = ETAPES.filter(e => etapes?.[e.key]).length;
  const percent = Math.round((completed / ETAPES.length) * 100);

  return (
    <div className="rounded-2xl overflow-hidden shadow-xl" data-testid="dossier-valide-card">
      {/* Header sombre */}
      <div className="bg-[#0F172A] px-6 pt-6 pb-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src={JETSKI_ICON_URL} alt="Jet-ski" className="h-10 w-10 sm:h-12 sm:w-12 invert opacity-80" />
            <div>
              <h2 className="text-[#8DC63F] text-xl font-bold tracking-wide">BPJEPS Motonautisme</h2>
              <p className="text-slate-400 text-sm">Moniteur(trice) VNM</p>
            </div>
          </div>
          <div className="bg-[#8DC63F]/10 border border-[#8DC63F]/30 rounded-full px-4 py-1">
            <span className="text-[#8DC63F] text-xs font-semibold uppercase tracking-wider">Formation Professionnelle</span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] px-6 pb-6">
        <div className="flex flex-col sm:flex-row items-start gap-6 sm:gap-8">
          {/* Checklist */}
          <div className="flex-1 space-y-3">
            {ETAPES.map((etape) => {
              const done = etapes?.[etape.key];
              return (
                <div
                  key={etape.key}
                  className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all ${
                    done 
                      ? 'bg-[#8DC63F]/10 border border-[#8DC63F]/20' 
                      : 'bg-slate-800/50 border border-slate-700/50'
                  }`}
                  data-testid={`etape-${etape.key}`}
                >
                  {done ? (
                    <CheckCircle className="h-5 w-5 text-[#8DC63F] flex-shrink-0" />
                  ) : (
                    <div className="h-5 w-5 rounded-full border-2 border-slate-600 flex-shrink-0" />
                  )}
                  <span className={`text-sm font-medium ${done ? 'text-[#8DC63F]' : 'text-slate-500'}`}>
                    {etape.label}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Progress circle */}
          <div className="flex flex-col items-center gap-3 pt-2 self-center">
            <ProgressCircle percent={percent} />
            <div className="text-center">
              <p className="text-slate-400 text-xs">{completed}/{ETAPES.length} etapes</p>
            </div>
          </div>
        </div>

        {/* Status banner */}
        <div className="mt-5 bg-[#8DC63F] rounded-xl p-4 flex items-center gap-3" data-testid="validation-banner">
          <CheckCircle className="h-6 w-6 text-[#0F172A] flex-shrink-0" />
          <div>
            <p className="text-[#0F172A] font-bold text-sm">Dossier accepte</p>
            <p className="text-[#0F172A]/70 text-xs">En attente de convocation aux tests de selection</p>
          </div>
        </div>

        {/* Footer info */}
        {dateValidation && (
          <div className="mt-3 flex items-center gap-2 justify-end">
            <Clock className="h-3.5 w-3.5 text-slate-500" />
            <span className="text-xs text-slate-500">
              Valide le {new Date(dateValidation).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DossierValideCard;
